import { SearchConfigProvider } from "../collectionbrowse-components/js/context/searchConfigContext";
import { SearchView } from "../collectionbrowse-components/js/views/search";

import * as d3 from "d3";
import * as Plot from "@observablehq/plot";

import React, {useState,useEffect,useRef} from 'react';
import ReactDOM from 'react-dom/client';

import csvArtworkDataUrl from '../data/artworks-count-year-techniques.csv?url';
import csvLivedPlacesDataUrl from '../data/okeeffe-livedplaces-dates.csv?url';

const barColors = [ "#D4C098", "#A9B5BA", "#5F859B", "#AF3B3D", "#B96C3E", "#825E85", "#5B5955", "#6F8261" ]
const eraColors = [ "#EDE3CF", "#CFCACF", "#D0D6CD", "#E1B898", "#D8DEE1", "#D4B1B0" ]

const dataMapping = {
    isReference: (dataSource) => {
      return dataSource._source.type === 'art-ref' || dataSource._source.type.includes('art-ref')
    },
    displayType: (dataSource) => { return `${( dataSource._source.caption.owner ?? [] ).join(', ')}` },
    showDisplayType: true,
    dateLabel: (dataSource) => {

      if ( typeof dataSource._source.timespan?.label === "string" ) {
        return `${dataSource._source.timespan?.label}  (CR ${ (dataSource._source.caption.catalog_number ?? [] ).join(', ') })`
      } if ( Array.isArray(dataSource._source.timespan?.label) ) {
        return `${dataSource._source.timespan?.label.join(', ')}  (CR ${ (dataSource._source.caption.catalog_number ?? [] ).join(', ') })`
      } else {
        return `${dataSource._source.timespan?.label ?? ''}  (CR ${ (dataSource._source.caption.catalog_number ?? [] ).join(', ') })`
      }
    },
    makers: (dataSource) => { return (dataSource._source.production_technique.label ?? '') },
    materials: (dataSource) => { return dataSource._source.classified_as?.join(', ') ?? '' },
    dimension: (dataSource) => { return dataSource._source.extent?.join(', ') ?? '' },
    isArtObject: (dataSource) => { return (dataSource._source) && (dataSource._source.type) && (typeof dataSource._source.type == 'string') && (dataSource._source.type == 'art') ? true : false },
    label: (dataSource) => { return dataSource._source.label.join('')  },
    link: (dataSource) => { return `/${dataSource._id}` },
    imageSrcSet: (dataSource,baseWidth=242,densities=[1,2,3]) => {
      let primaryUrl = dataSource._source.representation?.primary;

      if (primaryUrl === undefined || primaryUrl === null) {
        return primaryUrl
      }

      let height = dataSource._source.representation?.height ?? 9999;
      let width = dataSource._source.representation?.width ?? 9999;

      let url = new URL(primaryUrl);
      let iiifParams = url.pathname.split('/').slice(-4).join('/');

      return densities.map( density => {

          let densityParams = [ 'full', `,${ Math.min( Number(height), baseWidth*density) }`, '0', 'default.jpg' ].join('/')
          let imageIdPath = primaryUrl.replace(iiifParams,densityParams)

          return `${imageIdPath} ${Number(density)}x`;

        }).join(', ')
    },
    imageUrl: (dataSource) => { return dataSource._source.representation?.primary?.replace('square/!240,240', 'full/,242') }, // returns URL
    description: (dataSource) => { return '' },
    credit: (dataSource) => {
      return ( dataSource._source.caption.credit ?? []).join(', ');
    },
    copyright: (dataSource) => {
      return ( dataSource._source.caption.rights ?? []).join(', ') ;
    },
    currentOwner: (dataSource) => {
      return ( dataSource._source.caption.owner ?? []).join(', ') ;
    },
    accession: (dataSource) => {
      return ( dataSource._source.accession ?? []).join(', ') ;
    }
}
const searchConfig = {
    showTabs: false,
    tabs: [

    ],
    labels: [
      {
        name: "filterBy",
        label: "Filter By"
      },
      {
        name: "filteredBy",
        label: "Filtered By"
      },
      {
        name: "filtersButton",
        label: "Filters"
      },
      {
        name: "clearFilters",
        label: "Clear Filters"
      },
      {
        name: "sortBy",
        label: "Sort"
      },
      {
        name: "resultsShowing",
        label: "Showing"
      },
      {
        name: "resultsOf",
        label: "of"
      },
      {
        name: "resultsPage",
        label: "page"
      },
      {
        name: "resultsFor",
        label: "Results for"
      },
      {
        name: "resultsResults",
        label: "results"
      },
      {
        name: "close",
        label: "Close"
      },
      {
        name: "noResultsLine1",
        label: "No results found matching"
      },
      {
        name: "noResultsLine2",
        label: "Please try removing filters or try a different search term."
      },
      {
        name: "artObjectBadge",
        label: "museum object"
      },
      {
        name: "documentObjectBadge",
        label: "document"
      },
      {
        name: "resultsType",
        label: "Art"
      },
      {
        name: "resultsCountTab",
        label: "Art"
      },
      {
        name: "heroDescriptionText",
        label: "The Art collection includes artworks by Georgia O’Keeffe as well as by other artists including those in O’Keeffe’s circle; photographers of O’Keeffe and her surrounding landscapes; and contemporary artists illustrating a legacy of creativity in conversation with Georgia O’Keeffe’s life and work."
      }
    ],
    filters: [

    ],
    filterPanes: [

    ],
    sort: [
      {
        label: 'Title',
        field: 'label.keyword'
      },
      {
        label: 'Date',
        field: 'timespan.begin_of_the_begin'
      },
      {
        label: 'Creator',
        field: 'artist_label.keyword'
      },
    ],
    searchQuery: (queryString,filters,entityType, pageSize, fromIndex, sortTerm, sortDir, subquery ) => {

      let techFilt = filters.notTechniques ? filters.notTechniques : []
      let startDateFilt = filters.startDate
      let endDateFilt = filters.endDate

      let must = [{exists: {field: "production_technique.label"}}]
      if (startDateFilt && endDateFilt) {
        must.push({ range: { "timespan.middle": { gte: startDateFilt, lte: endDateFilt } } })
      }
      let must_not = techFilt.length > 0 ? [{"terms": {"production_technique.label": techFilt}}] : []

      return {"from":fromIndex,"size":50,"query":{"bool":{"must":[{"terms":{"type":["cr-object"]}}]}},"post_filter":{"bool":{must,must_not}},"sort":[{"caption.catalog_number.sort":{"order":"asc"}}],"aggs":{"materials":{"terms":{"field":"classified_as","size":500},"aggs":{"active":{"filter":{"bool":{"must":[]}}}}},"collection":{"terms":{"field":"collection","size":50},"aggs":{"active":{"filter":{"bool":{"must":[]}}}}},"artist":{"terms":{"field":"artist_label.keyword","size":500,"order":{"_key":"asc"}},"aggs":{"active":{"filter":{"bool":{"must":[]}}}}},"artist_is_gok":{"terms":{"field":"artist_is_gok"},"aggs":{"active":{"filter":{"bool":{"must":[]}}}}},"date":{"terms":{"size":40,"script":{"lang":"painless","source":"if (!doc['timespan.begin_of_the_begin'].empty) { return doc['timespan.begin_of_the_begin'].value.getYear() - doc['timespan.begin_of_the_begin'].value.getYear() % 10; } else { return 'Undated'; }"}},"aggs":{"active":{"filter":{"bool":{"must":[]}}}}},"theme":{"terms":{"field":"theme","size":500},"aggs":{"active":{"filter":{"bool":{"must":[]}}}}},"type":{"terms":{"field":"item_type","exclude":["Works of art"],"size":500},"aggs":{"active":{"filter":{"bool":{"must":[]}}}}},"role":{"terms":{"field":"role.label","size":500,"exclude":["origination source","origination_source"]},"aggs":{"active":{"filter":{"bool":{"must":[]}}}}},"meta_type":{"terms":{"field":"type","size":10,"exclude":["archive_component","archive"]},"aggs":{"active":{"filter":{"bool":{"must":[]}}}}}}}

    }
}

const animatePlot = (selectionToAnimate,keypointPlot,duration) => {
  // Animates `selectionToAnimate` according to `keypointPlot` over `duration`
  // - Texts and axes are fully replaced
  // - Rects are react across acording to selection order and transcribed for x, y, width, height accordingly

  // Remove the axes and tick-labels, replace with the zoomed plot's
  selectionToAnimate.select(".maxi-axis[aria-label='x-axis tick']").node().replaceChildren(...keypointPlot.selectAll(".maxi-axis > path").nodes())
  selectionToAnimate.select(".maxi-axis[aria-label='x-axis tick label']").node().replaceChildren(...keypointPlot.selectAll(".maxi-axis > text").nodes())
  selectionToAnimate.select(".mini-axis[aria-label='x-axis tick']").node().replaceChildren(...keypointPlot.selectAll(".mini-axis > path").nodes())
  selectionToAnimate.select(".mini-axis[aria-label='x-axis tick label']").node().replaceChildren(...keypointPlot.selectAll(".mini-axis > text").nodes())

  const annoSelection = document.querySelector(".annotation-text[aria-label='text']")
  if (annoSelection) {
    annoSelection.replaceChildren(...keypointPlot.selectAll(".annotation-text > text").nodes())

    // Set up the anontation animation, which will always have the same length
    const annoBarsSelector = eraColors.map( fill => { return `.viz-rect[fill='${fill}']` } ).join(", ")

    const newAnnoAttrs = keypointPlot.selectAll(annoBarsSelector).nodes()
                        .map( (node) => {
                          return { fill: node.getAttribute("fill"),
                                  x: node.getAttribute("x"),
                                  y: node.getAttribute("y"),
                                  width: node.getAttribute("width"),
                                  height: node.getAttribute("height")
                                } })

    selectionToAnimate.selectAll(annoBarsSelector)
                .transition()
                .ease(d3.easeCubic)
                .duration(duration)
                .attr("width",(d,i) => { return newAnnoAttrs.length > 0 ? newAnnoAttrs[i].width : 0 } )
                .attr("x",(d,i) => { return newAnnoAttrs.length > 0 ? newAnnoAttrs[i].x : 0} )
                .style("opacity", newAnnoAttrs.length > 0 ? 0.8 : 0 )

  }

  // Filtered plots don't have filtered-out rects in them, walk rects by fill type and width=0 any that don't match

  // Then walk the data bars and set width=0 if there are no keypoints
  for (const fill of barColors) {

    const dataBarSelector = `.viz-rect[fill='${fill}']`
    const keyDataBars = keypointPlot.selectAll(dataBarSelector)
    const keyDataBarAttrs = keyDataBars.nodes()
                      .map( (node) => {
                        return { fill: node.getAttribute("fill"),
                                x: node.getAttribute("x"),
                                y: node.getAttribute("y"),
                                width: node.getAttribute("width"),
                                height: node.getAttribute("height")
                              } })

    const selectedDataBars = selectionToAnimate.selectAll(dataBarSelector).nodes()

    if (keyDataBarAttrs.length===0) {
      selectionToAnimate.selectAll(dataBarSelector).transition()
              .ease(d3.easeCubic)
              .duration(duration)
              .attr("height",0)
              .attr("y",(d,i,nodes) => { return Number(nodes[i].getAttribute("height"))+Number(nodes[i].getAttribute("y")) } )

    } else {

      selectionToAnimate.selectAll(dataBarSelector).transition()
              .ease(d3.easeCubic)
              .duration(duration)
              .attr("width",(d,i) => { return keyDataBarAttrs[i].width } )
              .attr("x",(d,i) => { return keyDataBarAttrs[i].x } )
              .attr("height",(d,i) => { return keyDataBarAttrs[i].height } )
              .attr("y",(d,i) => { return keyDataBarAttrs[i].y } )

    }

  }

}

const renderToolTipGroup = (foundData,yearCount,xPos,yPos,fillColor,domain,viewWorksHandler,plotConfig,imgHeight=56,textHeight=25,buttonHeight=30,imgDensities=[1,2,3]) => {
    // Uses Plot to generate a tooltip group and returns it

    let binPartition = Plot.binX( { y:"sum" }, { x: "Year",  y: d => { return d.Total > 0 && d.Total < 3 ? 3 : d.Total }, fill: "Type", insetLeft: 2, insetRight: 2, insetBottom: 2, thresholds: "1 year" })

    const tipYear = new Date(foundData.Year).getFullYear()
    const yearFacet = foundData.Type
    const yearFacetCount = foundData.TotalForTip
    const tipAriaDescription = `O'Keeffe produced ${yearCount} works in ${tipYear}, of which ${yearFacetCount} were ${yearFacet}`

    // Bootstrap image row -- fills the tooltip path with a foreignObject populated with a div + flexbox bits

    // First calculate the div width based on image size
    const images = foundData.Images
    const gap = 4
    let divWidth;
    if (foundData.Total < 4){ //even when two image is there the text is wrapping
       divWidth = 155
    } else {
       divWidth = images.reduce((acc,img) => { return gap + acc + Math.round(imgHeight * Number(img.width) / Number(img.height) ) -10 },0)
    }

    // Set the anchor point, etc based on size
    let anchor = ""
    if (yPos - (imgHeight + textHeight + buttonHeight) < 0) {
      anchor = "top"
    } else if(xPos - divWidth/2 < plotConfig.marginRight) {
      anchor = "bottom-left"
    } else if (xPos + divWidth > plotConfig.width - plotConfig.marginRight) {
      anchor = "bottom-right"
    } else {
      anchor = "bottom"
    }

    // Now adjust the FO's origin to account for the tip anchor
    let foXPos, foYPos = [0, 0]

    switch (anchor) {
    case 'top':
      foXPos = -(divWidth + images.length * gap)/2
      foYPos = 15
      break
    case 'bottom':
      foXPos = -(divWidth + images.length * gap)/2
      foYPos = -imgHeight-textHeight-buttonHeight-15
      break
    case 'bottom-right':
      foXPos = -(divWidth + images.length * gap + 10)
      foYPos = -imgHeight-textHeight-buttonHeight-20
      break
    case 'bottom-left':
      foXPos = 10
      foYPos = -imgHeight-textHeight-buttonHeight-20
      break
    }

    let p = Plot.plot({
        className: "tip-visualization",
        x: { clamp: true, domain },
        ...plotConfig,
        color: { range: barColors },
        marks: [
            Plot.tip([foundData],{"x": "Year", anchor})
             ]
    })


    // Remove any text spans from the stock component
    d3.select(p).selectAll("[aria-label=tip] > g > text > tspan").remove()

    let mainPath = d3.select(p).select("[aria-label=tip] > g > path").attr("filter", "").attr("style","pointer-events: auto;")

    let fo = d3.select(p).select("[aria-label=tip] > g")
                            .insert("foreignObject",":last-child")
                            .attr("class","tooltip-content")
                            .attr("x",foXPos)
                            .attr("y",foYPos)
                            .attr("height",imgHeight+textHeight+buttonHeight)
                            .attr("width",divWidth + images.length * gap)

    let textDiv = fo.append("xhtml:div")
      .attr("class","tooltip-total")

    textDiv.append("xhtml:div").attr("class", "tooltip-total-text")
        .text(`${ tipYear }: `).append("xhtml:span").text(`${ yearCount }`)

    textDiv.append("xhtml:div").attr("class", "tooltip-total-text")
        .text(`${yearFacet}: `).append("xhtml:span").text(`${yearFacetCount}`)

    let imgDiv = fo.append("xhtml:div").attr("class", "image-container")

    images.forEach( (img,i) => {

      let infoWidth = Number(img.width)
      let infoHeight = Number(img.height)
      const width = Math.round(imgHeight * (infoWidth / infoHeight))

      let pic = imgDiv.append("xhtml:picture")

      imgDensities.forEach( (d) => {
        if (d===1) { return } // Skip 1 since it's the img tag
        const imgUrl = new URL(`full/,${imgHeight*d}/0/default.jpg`,`${img.id}/`)
        pic.append("xhtml:source")
            .attr("srcset",`${imgUrl.href} ${d}x`)
      })

      const img1xUrl = new URL(`full/,${imgHeight}/0/default.jpg`,`${img.id}/`)

      pic.append("xhtml:img")
              .attr("src",img1xUrl.href)
              .attr("height",imgHeight)
              .attr("width",width)
              .attr("alt","")
              .attr("crossorigin","anonymous")

    })

    fo.append("xhtml:button")
          .attr("class", "")
          .on("pointerdown",(event) => { viewWorksHandler(event,tipYear,yearFacet) } )
          .text(`View Works`)

    d3.select(p).select("[aria-label=tip] > g").attr("transform",`translate(${xPos},${yPos})`)
    d3.select(p).select("[aria-label=tip]").attr("class","tooltip-container")
    d3.select(p).select("[aria-label=tip]").attr("aria-describedby",tipAriaDescription)
    let tip = d3.select(p).select("[aria-label=tip]").node()

    return tip

}

const zoomScale = (data,transform,plotConfig) => {
    const {marginLeft,insetLeft,width} = plotConfig
    const extent = d3.extent(data, ({Year}) => Year)
    const x = d3.scaleTime(extent,[marginLeft+insetLeft,width])
    const zoomX = new d3.ZoomTransform(transform.k,transform.x,transform.y)
    const rescaled = zoomX.rescaleX(x)

    return rescaled
}

const barPlot = ( data,
                  annotations,
                  transform,
                  filters,
                  plotConfig={},
                  passedDomain=undefined
                ) => {
    const { width,
        height,
        marginLeft,
        marginBottom,
        marginRight,
        marginTop,
        tickSize,
        insetLeft,
        insetRight,
        colorLegend } = plotConfig

    const rescaledX = zoomScale(data,transform,plotConfig)

    const minDomain = Math.min(...data.map( d => d.Year.getTime() ), ...annotations.flatMap(d=>d).map( d => d.YearBegin.getTime() ) )
    const maxDomain = Math.max(...data.map( d => d.Year.getTime() ), ...annotations.flatMap(d=>d).map( d => d.YearEnd.getTime() ) )

    const typeDomain = Array.from(new Set( data.map( d => d.Type) ))
    const typesTotals = typeDomain.map( tech => { return { tech, total: data.filter( d => d.Type===tech ).reduce( (acc,cur) => acc+cur.Total ,0) } } ).sort( (a,b) => a.total-b.total ).reverse()
    const colorDomain = typesTotals.map( t => t.tech ) 

    let domain = passedDomain ?? [ new Date( rescaledX.domain()[0] ), new Date( rescaledX.domain()[1] ) ]

    const yBins = d3.bin().thresholds(domain[1].getFullYear()-domain[0].getFullYear()).value((d) => d.Year)(data)

    const yearBins = data.reduce((acc,d) => {
      if (d.Year in acc) {

        return { ...acc, [d.Year]: acc[d.Year].concat([d]) }
      } else {
        return {...acc, [d.Year]: new Array(d) }
      }

    },new Object())

    const yMax = Math.max(...Object.entries(yearBins).map( ([y,yDatas]) => { return yDatas.reduce((acc,cur) => acc+cur.Total,0) } ))

    let frm = Plot.frame()

    let xAxisMaxiTicks = Plot.axisX({padding: 0.5, ticks: "3 years", tickSize: plotConfig.maxiTickSize, stroke: "#AFC6D1", textAnchor: "end", tickRotate: -45})
    let xAxisMiniTicks = Plot.axisX({padding: 0.5, tickFormat: "", ticks: "1 year", tickSize: plotConfig.miniTickSize, stroke: "#D8DEE1", textAnchor: "end", tickRotate: -45, label: "Year", labelAnchor: "left", labelArrow: "none", fontSize: 20, labelOffset: 30})
    let binPartition = Plot.binX( { y:"sum" }, { filter: d => { return !filters.includes(d.Type) } ,x: "Year",y: d => { return d.Total > 0 && d.Total < 3 ? 3 : d.Total }, fill: "Type", insetLeft: 2, insetRight: 2, insetBottom: 2, thresholds: "1 year" })

    // Set up annotations
    let plotAnnos = []
    if (annotations.length > 0) {
        // Only one plot annotation right now, era bars:
        // - Rotate through the era colors
        // - Have constant width
        // - Set their y in one of 3 rows

        const maxEraY = yMax * 0.8 // ~80% up the viz height
        const width = yMax * 0.05 // ~10px
        const y1 = (d) => { return maxEraY - ( d.Row % 3 ) * width  }
        const y2 = (d) => { return maxEraY - ( d.Row % 3 ) * width + width }
        const yMid = (d) => { return maxEraY - ( d.Row % 3 ) * width + width / 2 }
        const fillRowRotate = (d) => { return eraColors[d.Row%eraColors.length] }
        const x2LowerClamp = (d) => {

            if (d.YearBegin.getTime()!==d.YearEnd.getTime()) {
                return d.YearEnd
            }

            let yearBegin = new Date(d.YearBegin)
            let fullYear = new Date(yearBegin.getFullYear()+1,yearBegin.getMonth()+6,yearBegin.getDate())

            return fullYear

        }

        let annos = annotations[0]
        let filteredAnnos = annos.filter( (d) => { return ( d.YearEnd.getTime() > domain[0].getTime() && d.YearEnd.getTime() < domain[1].getTime() ) || ( d.YearBegin.getTime() > domain[0].getTime() && d.YearBegin.getTime() < domain[1].getTime() ) })
        // Filter the bar text for if its bar is still onscreen, set some minimum sizes
        let eraBars = Plot.rectX(annos,{x1:"YearBegin",x2: x2LowerClamp,y1, y2, insetBottom: 2, fill: (d) => d.Fill, fillOpacity: 0.8 })
        let eraTexts = Plot.text(annos,{x:"YearBegin",y:yMid,text: "StateAbbr",textAnchor: "start",insetLeft: 2, filter: (d) => { return ( d.YearEnd.getTime() >= domain[0].getTime() && d.YearEnd.getTime() <= domain[1].getTime() ) || ( d.YearBegin.getTime() >= domain[0].getTime() && d.YearBegin.getTime() <= domain[1].getTime() ) } })

        plotAnnos = plotAnnos.concat([eraBars,eraTexts])

    }

    // Determine the x-axis range at this zoom scale
    // NICER: Consistency of rows for eras -- maybe use force direction?
    // NICER: Selection state for tipped rect
    // NICER: Pass pattern funcs to the mini/maxi axes to ensure the lowest date is the start of the tick patterns for long-w-text-short-short-short
    // NICER: drop shadow at frame left and frame right if the graph can pan
    // NICER: During animations text should move instead of popping in
    // NICER: Animate by reconstructing the X scale transformation and create an animation transition for attrs (faster, smoother)
    // NICER: If range dates are ==, only show the one date
    // NICER: Allow padding to lower / upper range of the annotation dates

    // FIXME: Share URL button / URL scheme - remember og:tags, add URL state handling for viz, and enable a "captured URL bar" mode for search
    // FIXME: Mobile update: disable tooltip
    // FIXME: Generate a plot w/ a figure caption, title, and legend

    const plot = Plot.plot({
                    className: "hero-visualization",
                    x: { clamp: true, domain },
                    y: { domain: [0, yMax]},
                    figure: false,
                    ...plotConfig,
                    color: {legend: colorLegend===true, className: "counts-color-legend", swatchWidth: 8, swatchHeight: 16, columns: 1, domain: colorDomain, range: barColors },
                    marks: [
                        frm,
                        xAxisMaxiTicks,
                        xAxisMiniTicks,
                        Plot.axisY({ticks: 3, label: "", labelArrow: "none" }),
                        Plot.gridY({ticks: [50,100,150]}),
                        Plot.rectY(data, binPartition),
                        ...plotAnnos,
                         ]
                })

    // Add classes for maxi and mini tick groups -- these must match the insertion order in `marks` above
    d3.select(plot).selectAll("[aria-label='x-axis tick label']").nodes().forEach( (el,idx) => {
        if (idx===0) {
            el.classList.add("maxi-axis")
        } else {
            el.classList.add("mini-axis")
        }
    })

    d3.select(plot).selectAll("[aria-label='x-axis tick']").nodes().forEach( (el,idx) => {
        if (idx===0) {
            el.classList.add("maxi-axis")
        } else {
            el.classList.add("mini-axis")
        }
    })

    d3.select(plot).selectAll("[aria-label='y-axis tick label']").nodes().forEach( (el,idx) => {
      el.classList.add("y-axis")
    })

    d3.select(plot).selectAll("rect[aria-label=frame]").attr("class","viz-frame-rect")
    d3.select(plot).selectAll("[aria-label=rect] > rect").attr("class","viz-rect")

    d3.select(plot).selectAll("[aria-label=text]").attr("class","annotation-text")

    // Drop shadow filters for possible selection states -- must be at top of the SVG so url(#XXX) selectors work
    d3.select(plot)
        .select(".hero-visualization")
        .insert("defs",":first-child")
            .append("filter")
                .attr("id","rectShadow")
                .attr("width","160%")
                .attr("height","160%")
                .append("feDropShadow")
                    .attr("dx",0.25)
                    .attr("dy",0.25)
                    .attr("stdDeviation",1.5)

    return plot

}

function ColorSwatchCheckboxes({colors,domain,checkboxHandler,filters,inputsDisabled}) {
  return colors.map( (color,i) => {
    return inputsDisabled && filters.includes(domain[i]) ? '' : <div key={i} className="counts-color-legend-swatch">
            <input type="checkbox" className="custom-checkbox" disabled={inputsDisabled} value={ domain[i] } aria-label={ domain[i] } checked={!filters.includes(domain[i])} onChange={checkboxHandler}/>
            <svg width="8" height="16" fill={color}>
              <rect width="100%" height="100%"></rect>
            </svg>
            <div className="counts-color-legend-swatch-label" title={domain[i]} >{domain[i]}</div>
            </div>
  })
}

function Visualization({title,filters,dataUrls,endpoint,minZoom=1,maxZoom=64}) {

    const dataUrl = dataUrls.main
    const annotationDataUrls = dataUrls.annotations

    const [earlyDate,setEarlyDate] = useState(1897);
    const [lateDate,setLateDate] = useState(1984);
    const [filt,setFilt] = useState(filters);
    const [data,setData] = useState(null);
    const [annotationDatas,setAnnotationDatas] = useState(null);
    const [showAnnotations,setShowAnnotations] = useState(false);
    const [activatedFilters,setActivatedFilters] = useState({startDate: 1897, endDate: 1984, notTechniques: []});

    const [zoomTransform,setZoomTransform] = useState({k:1,x:0,y:0});

    const [savedPlot,setSavedPlot] = useState(null)

    const [domain,setDomain] = useState([null,null]);
    const [types,setTypes] = useState([]);

    const [tooltipIndex,setTooltipIndex] = useState(-1);
    const [tooltipY,setTooltipY] = useState(0);
    const [tooltipX,setTooltipX] = useState(0);
    const [tooltipChipFill,setTooltipChipFill] = useState("#000000")
    const [tooltipStickied,setTooltipStickied] = useState(false)

    const vizRef = useRef(null);
    const savedPlotRef = useRef(null);
    const zoomInstance = useRef(null);
    const tooltipIndexRef = useRef(null);
    const tooltipStickiedRef = useRef(null);
    const filtRef = useRef(null);
    const showAnnotationsRef = useRef(null);

    const plotConfig = { width: 1100,
                        height: 550,
                        marginLeft: 70,
                        marginBottom: 70,
                        marginRight: 20,
                        marginTop: 0,
                        maxiTickSize: 12,
                        miniTickSize: 9,
                        insetLeft: 5,
                        insetRight: 5,
                        insetTop: 2,
                        insetBottom: 2,
                    }

    const viewWorksHandler = (event,date,facet) => {
      event.preventDefault();
      event.stopPropagation();

      if (date === undefined && facet === undefined) {
        document.getElementById("view-works")?.scrollIntoView({behavior:'smooth'})
      } else if (date !==undefined && facet !== undefined) {
        const facets = Array.from(new Set(data.map(data => data.Type)))

        setActivatedFilters({startDate: date, endDate: date, notTechniques: facets.filter( item => item!==facet)})
        document.getElementById("view-works")?.scrollIntoView({behavior:'smooth'})

      }
    }

    const checkboxHandler = (event) => {
      if (event.target.checked) {
          setFilt((filt) => filt.filter( item => item !== event.target.value ))
      } else {
          setFilt((filt) => filt.concat([event.target.value]))
      }
    }

    const resetPlotHandler = (event) => {

      setFilt([])
      zoomInstance.current?.scaleTo(d3.select(vizRef.current).select('.hero-visualization'),1.0)

      const earliestYear = Math.min(...data.map(d => { return d.Year.getFullYear()  }) )
      const latestYear = Math.max(...data.map(d => { return d.Year.getFullYear() }) )

      setEarlyDate(earliestYear)
      setLateDate(latestYear)
      setTooltipIndex(-1)
      setTooltipStickied(false)

    }

    const keydownHandler = (event) => {
      // Adapted from https://gist.github.com/Fil/2768b0b0d23cd0085f86
      const step = 100
      const key = event.key || event.keyCode; // safari doesn't know .key

      switch (key) {
        case 'Esc':
        case 27:
            resetPlotHandler()
            break;
        case '+':
        case '=':
        case 187:
            zoomInstance.current?.scaleBy(d3.select(vizRef.current).select('.hero-visualization').transition(250),1.5)
            break;
        case '-':
        case 189:
            zoomInstance.current?.scaleBy(d3.select(vizRef.current).select('.hero-visualization').transition(250),0.5);
            break;
        case 'Left':
        case 'ArrowLeft':
        case 37:
            zoomInstance.current?.translateBy(d3.select(vizRef.current).select('.hero-visualization').transition(250),step,0);
            break;
        case 'Right':
        case 'ArrowRight':
        case 39:
            zoomInstance.current?.translateBy(d3.select(vizRef.current).select('.hero-visualization').transition(250),-step,0);
            break;
        case 'Up':
        case 38:
            break;
        case 'Down':
        case 40:
            break;
        default:
            break;
      }
    }

    const applyDateRangeHandler = (event) => {
      const fullDomain = d3.extent(data, ({Year}) => Year)
      const domain = [ new Date( earlyDate, 0, 1 ), new Date( lateDate, 0, 1) ]
      let a = barPlot(data,showAnnotations ? annotationDatas : [],{k:1,x:0,y:0},filt,plotConfig,domain)

      let cur = d3.select(vizRef.current)
      let tar = d3.select(a)

      // scaleTo(), etc take the unzoomed (k=1.0) coordinate system for points, so calculate our new viewpoint center 
      const origXScale = d3.scaleTime(fullDomain,[plotConfig.marginLeft+plotConfig.insetLeft,plotConfig.width-plotConfig.marginRight-plotConfig.insetRight])

      const fullDomainLength = fullDomain[1].getTime() - fullDomain[0].getTime()
      const domainLength = domain[1].getTime() - domain[0].getTime()
      const newK = fullDomainLength / domainLength

      const absOriginX = origXScale(domain[0])
      const absCenterX = absOriginX + (origXScale(domain[1])-absOriginX)/2      

      const {k,x,y} = d3.zoomTransform(d3.select(vizRef.current).select('.hero-visualization').node())

      if (newK===k) {
        zoomInstance.current?.translateTo(d3.select(vizRef.current).select('.hero-visualization'),absCenterX,10)            
      } else {
        zoomInstance.current?.scaleTo(d3.select(vizRef.current).select('.hero-visualization'),newK,[ absCenterX ,10])            
      }

      // The zoom calcs only get us so close, so manually set the rest
      animatePlot(cur,tar,250)
      setEarlyDate(earlyDate)
      setLateDate(lateDate)
      setSavedPlot(a)

    }

    const tooltipMoveEnterHandler = (event) => {

      if (tooltipStickiedRef.current!==null && tooltipStickiedRef.current) { return }

      // First, select our viz and map the event's screen coords to it
      let svg = d3.select(vizRef.current).select(".hero-visualization")
      let ctm = svg.node().getScreenCTM()
      let pt = svg.node().createSVGPoint()

      pt.x = event.clientX
      pt.y = event.clientY

      let ptInPlot = pt.matrixTransform(ctm.inverse())

      // Do hit testing on the rects
      let hits = svg.selectAll(".viz-rect").nodes().filter( node => {
          return node.isPointInFill(ptInPlot) || node.isPointInStroke(ptInPlot)
      })

      // Also hit test any tip paths that are onscreen
      let tipPath = svg.selectAll("[aria-label='tip'] > g > path").nodes()
      let tipHits = false

      if (tipPath) {
        tipPath.forEach( (node) => {
          // NB: Because tips are drawn at 0,0 and then translated we have to transform the screen point for each path
          const pathCTM = node.getScreenCTM()
          const ptInPath = pt.matrixTransform(pathCTM.inverse())

          if (node.isPointInFill(ptInPath) || node.isPointInStroke(ptInPath)) {
            tipHits = true
          }
        })
      }

      if (hits.length > 0 && !tooltipStickiedRef.current) {
          const x = Number(hits[0].getAttribute("x"))
          const y = Number(hits[0].getAttribute("y"))
          const width = Number(hits[0].getAttribute("width"))
          const height = Number(hits[0].getAttribute("height"))

          const fill = hits[0].getAttribute("fill")

          const xScale = savedPlotRef.current.scale("x")
          const fillScale = savedPlotRef.current.scale("color")

          const stamp = xScale.invert(ptInPlot.x)
          const date = new Date(stamp)

          let tech = ""
          fillScale.range.forEach( (f,i) => {
              if (f===fill && i < fillScale.domain.length) {
                  tech = fillScale.domain[i]
              }
          })

          let d = data.findIndex( (item) => item.Year.getFullYear() === date.getFullYear() && item.Type === tech )
          setTooltipIndex( (curVal) => {

            // Remove the existing tip group if we're already showing a tip
            if (curVal > -1 && curVal !== d) {
              vizRef?.current.querySelector(".hero-visualization").querySelector("[aria-label=tip]")?.remove()
            }
            return d
          })
          setTooltipY(y+height/2)
          setTooltipX(x+width/2)
          setTooltipChipFill(fill)
      } else if ( tipHits ) {
        return
      } else {
        setTooltipIndex(-1)
      }
    }

    const tooltipExitHandler = (event) => {
      if (tooltipStickiedRef.current!==null && !tooltipStickiedRef.current) { setTooltipIndex(-1) }
    }

    const toolTipDownHandler = (event) => {

      if (tooltipIndexRef.current!==null && tooltipIndexRef.current > -1 ) {
        setTooltipStickied( (stickied) => !stickied )
      } else {
        setTooltipStickied(false)
        setTooltipIndex(-1)
      }

    }

    const zoomTransformFilter = (event) => {
      // Returns `true` if zoom should happen, `false` if not
      // The else branch here is d3-zoom's default handler -- see https://d3js.org/d3-zoom#zoom_filter
      if ( tooltipStickiedRef.current===true || ( tooltipIndexRef.current !== null && tooltipIndexRef.current > -1) ) { return false }

      const svg = d3.select(vizRef.current).select(".hero-visualization")
      const ctm = svg.node().getScreenCTM()
      const pt = svg.node().createSVGPoint()

      pt.x = event.clientX
      pt.y = event.clientY

      const ptInPlot = pt.matrixTransform(ctm.inverse())
      const n = svg.select(".viz-frame-rect").node()

      if ( n.isPointInFill(ptInPlot)|| n.isPointInStroke(ptInPlot) ) { return (!event.ctrlKey || event.type === 'wheel') && !event.button}
    }

    const zoomHandler = ({type,transform}) => {
      // On zoom:
      // - Create a new plot with this zoom scale and then transcribe the axes' and bars' new positions, widths, and text

      setZoomTransform({k:transform.k,x:transform.x,y:transform.y})

      const zoomedPlot = barPlot(data,showAnnotationsRef.current ? annotationDatas : [],transform,filtRef.current,plotConfig)

      if (zoomedPlot===null) { return }
      setSavedPlot(zoomedPlot)

      let zoomedPlotSelection = d3.select(zoomedPlot)
      let plotSelection = d3.select(vizRef.current).select('.hero-visualization')

      animatePlot(plotSelection,zoomedPlotSelection,0)

      if (type==="end") {

        const rescaledX = zoomScale(data,transform,plotConfig)

        const minDomain = new Date(rescaledX.domain()[0]).getFullYear()
        const maxDomain = new Date(rescaledX.domain()[1]).getFullYear()

        setEarlyDate(minDomain)
        setLateDate(maxDomain)
      }
    }

    const downloadImageHandler = () => {

      const marginLeft = 120
      const marginTop = 20
      const captionHeight = 20
      const captionInsetBottom = 10
      const legendMarginLeft = 10
      const legendChipWidth = 8 
      const legendChipHeight = 16
      const legendLineHeight = 25
      const legendMarginTop = 20

      // Create a plot with our current domain with some overrides (margins, legend, and figure caption)
      const domain = [ new Date( earlyDate, 0, 1 ), new Date( lateDate, 0, 1) ]
      const p = barPlot(data,showAnnotations ? annotationDatas : [],{k:1,x:0,y:0},filt,{...plotConfig, marginLeft,marginTop,colorLegend: true, caption: `Artworks created over O'Keeffe's lifetime, ${earlyDate} - ${lateDate}`, figure: true },domain)

      // Transcribe the figure caption and legend into the SVG
      const svg = d3.select(p).select('.hero-visualization')
      const legendNodes = d3.select(p).selectAll('.counts-color-legend-swatch').nodes()
      const captNode = d3.select(p).select('figcaption').node()
      const frameNode = svg.select('.viz-frame-rect').node()

      const capt = svg.append('g')
          .attr('class','caption')
          .attr('transform',frameNode.getAttribute('transform'))
      
      capt.append('text')
        .text(captNode.innerHTML)
        .attr('text-anchor','center')
        .attr('x',Number(frameNode.getAttribute('x'))+Number(frameNode.getAttribute('width'))/2 )
        .attr('y',plotConfig.height - captionInsetBottom)
        .attr('font-size','16')

      const leg = svg.append('g')
                    .attr('class','legend-rect')

      legendNodes.forEach( (swt,i) => {
        const y = legendMarginTop+legendLineHeight*(i+1)

        const rect = d3.select(swt).select('svg')
                        .attr('x',legendMarginLeft)
                        .attr('y',y)
                        .node()

        const textEl = d3.select(swt).select('.counts-color-legend-swatch-label').node()

        leg.append('text')
          .attr('text-anchor','start')
          .attr('dominant-baseline','middle')
          .attr('x',legendMarginLeft+legendChipWidth*2)
          .attr('y',y+legendChipHeight/2)
          .text(textEl.innerHTML)

        leg.node().append(rect)

      }) 

      // Use an `XMLSerializer` to create a png from the SVG and download it
      const s = (new XMLSerializer()).serializeToString(svg.node())
      const b = new Blob([s],{type: "image/svg+xml;charset=utf-8"})

      const url = window.URL.createObjectURL(b)
      const image = new Image()
      image.width = savedPlot.width.baseVal.value
      image.height = savedPlot.height.baseVal.value
      image.src = url

      image.onload = () => {
        const canvas = document.createElement("canvas")
        canvas.width = image.width
        canvas.height = image.height

        const ctx = canvas.getContext('2d')
        ctx.drawImage(image,0,0)
        window.URL.revokeObjectURL(url)

        const imgURI = canvas.toDataURL("image/png").replace("image/png","image/octet-stream")
        const a = document.createElement('a');
        const now = new Date( Date.now() )
        a.download = `okeeffe-museum-techniques-visualization-${now.getUTCFullYear()}-${now.getUTCMonth()}-${now.getUTCDay()}.png`; // filename
        a.target = '_blank';
        a.href = imgURI;

        a.dispatchEvent(new MouseEvent('click', {
            view: window,
            bubbles: false,
            cancelable: true
        }));

      }
    }

    useEffect(() => {
        if (vizRef===null || data===null || annotationDatas===null ) {return}

        // If there isn't a plot, initialize it and setup the tip handlers, otherwise just animate
        if (savedPlot===null) {

          let p = barPlot(data.concat(),showAnnotations ? annotationDatas : [],zoomTransform,filt,plotConfig)
          if (p===null) { return }

          const { marginLeft,insetLeft,marginTop,marginRight,insetRight,marginBottom,width,height,insetTop,insetBottom } = plotConfig
          const plotExtents = [[marginLeft+insetLeft,marginTop+insetTop],[width-marginRight-insetRight,height-marginBottom-insetBottom]]

          const zoom = d3.zoom()
                          .filter(zoomTransformFilter)
                          .interpolate(d3.interpolate)
                          .translateExtent(plotExtents)
                          .scaleExtent([minZoom,maxZoom])
                          .on("zoom start end", zoomHandler)

          vizRef.current.append(p)
          vizRef.current.querySelector(".hero-visualization").onpointermove = tooltipMoveEnterHandler
          vizRef.current.querySelector(".hero-visualization").onpointerenter = tooltipMoveEnterHandler
          vizRef.current.querySelector(".hero-visualization").onpointerexit = tooltipExitHandler
          vizRef.current.querySelector(".hero-visualization").onpointerdown = toolTipDownHandler

          d3.select(p).call(zoom)
          d3.select('body').on('keydown',keydownHandler)

          zoomInstance.current = zoom
          setSavedPlot(p)

        } else {

          // console.log(d3.zoomTransform(d3.select(vizRef.current).select('svg').node()).k)

          let p = barPlot(data.concat(),showAnnotations ? annotationDatas : [],zoomTransform,filt,plotConfig)
          animatePlot(d3.select(vizRef.current),d3.select(p),250)
          setSavedPlot(p)

        }
        showAnnotationsRef.current = showAnnotations
    },[vizRef,data,annotationDatas,showAnnotations,filt])

    useEffect(() => {
      filtRef.current=filt
    },[filt])

    useEffect(() => {
        savedPlotRef.current = savedPlot
    },[savedPlot])

    useEffect(() => {
        if (vizRef===null || data===null) { return }
        tooltipIndexRef.current = tooltipIndex
        tooltipStickiedRef.current = tooltipStickied

        if ( d3.select(vizRef.current).select(".hero-visualization").select("[aria-label=tip]") ) {
          d3.select(vizRef.current).select(".hero-visualization").selectAll("[aria-label=tip]").remove()
        }

        if ( tooltipIndex < 0 && !tooltipStickied ) {
            return
        }

        const rescaled = zoomScale(data,zoomTransform,plotConfig)
        const domain = [ new Date(rescaled.domain()[0]), new Date(rescaled.domain()[1]) ]

        let foundData = data.find((el,i) => i===tooltipIndex)

        if (foundData === undefined) { return }

        const yearCount = data.filter( (d) => d.Year.getTime() === foundData.Year.getTime() ).reduce((sum,cur) => { return sum + cur.TotalForTip },0)

        let tipEls = renderToolTipGroup({...foundData},yearCount,tooltipX,tooltipY,tooltipChipFill,domain,viewWorksHandler,plotConfig)
        if (tipEls === undefined) { return }
        vizRef.current.querySelector(".hero-visualization").append(tipEls)

    },[tooltipIndex,tooltipStickied])

    const dataParser = (body) => {

      let dat = d3.csvParse(body, (d) => {
        return {
            Year: new Date(+d.Year,0,1),
            Type: d.Type,
            Total: +d.Total,
            TotalForTip: +d.Total,
            Images: JSON.parse(d.Images)
        }
      })

      dat.sort( (a,b) => {
          if (a.Year.getFullYear() > b.Year.getFullYear()) {
              return 1
          } else if (a.Year.getFullYear() < b.Year.getFullYear()) {
              return -1
          }
          else if (a.Year.getFullYear() === b.Year.getFullYear()) {
              return 0
          }

      })

      setData(dat)
      let types = Array.from( new Set(dat.map(({Type}) => Type)) )
      setTypes(types)

      const earliestYear = Math.min(...dat.map(d => { return d.Year.getFullYear() }) )
      const latestYear = Math.max(...dat.map(d => { return d.Year.getFullYear() }) )

      setEarlyDate( Number.isNaN(earliestYear) ? 0 : earliestYear )
      setLateDate( Number.isNaN(latestYear) ? 0 : latestYear )

    }

    const annotationDataParser = (body,datas) => {

      let dat = d3.csvParse(body, (d) => {
          return {
             YearBegin: new Date(+d["begin date"],0,1),
             YearEnd: new Date(+d["end date"],0,1),
             StateAbbr: d.abbrev,
             State: d.State,
          }
      })
      dat.sort( (a,b) => {
          if (a.YearBegin.getFullYear() > b.YearBegin.getFullYear()) {
              return 1
          } else if (a.YearBegin.getFullYear() < b.YearBegin.getFullYear()) {
              return -1
          }
          else if (a.YearBegin.getFullYear() === b.YearBegin.getFullYear()) {
              return 0
          }
      })
      let fillKeys = Array.from(new Set(dat.map( (item) => { return item.StateAbbr })))
      dat = dat.map( (d,i) => { return {...d,Row: i,Fill: eraColors[Math.min(fillKeys.findIndex( fk => fk===d.StateAbbr),eraColors.length-1)] } } )
      datas.push(dat)

    }

    useEffect(() => {
      // Fetches all the data on mount, only sets after completing all annotationsData urls
      var datas = []
      fetch(dataUrl)
        .then( (resp) => resp.text() )
        .then( (body) => dataParser(body) )
        .catch( (err) => console.error(err) ) 

      var futures = []
      var annotations = []

      for (const url of annotationDataUrls) {
        futures.push( 
          fetch(url)
            .then( (resp) => resp.text() )
            .then( (body) => annotationDataParser(body,annotations) )
            .catch( (err) => console.error(err) )             
          )
      }

      // Bit of trickery here: check the null sentinel within the setter so we only set annotations once (allSettled returns an array of results)
      Promise.allSettled(futures).then( () => {setAnnotationDatas( (cur) => cur ?? annotations )} )

    },[])

    useEffect(() => {
      setActivatedFilters({startDate: earlyDate,endDate: lateDate,notTechniques: filt})
    },[earlyDate,lateDate,filt])

    let canZoomIn = zoomTransform.k < maxZoom
    let canZoomOut = zoomTransform.k > minZoom
    let canApply = true
    let canReset = zoomTransform.k > minZoom || earlyDate > 1897 || lateDate < 1984 || filt.length > 0

    const techs = Array.from(new Set( (data ?? []).map( d => d.Type) ))
    const techTotals = techs.map( tech => { return { tech, total: data.filter( d => d.Type===tech ).reduce( (acc,cur) => acc+cur.Total ,0) } } ).sort( (a,b) => a.total-b.total ).reverse()
    const techDomain = techTotals.map( t => t.tech ) 

    const [ openPane, setOpenPane ] = useState(null);

    return (
        <>
            <div className="viz-main py-5">
              <div className="columns is-vcentered">
                <div className="column is-full-mobile is-one-third-widescreen is-one-third-fullhd" >
                  <h2 className="page-type-subhead">Visualization</h2>
                  <h3 className="page-headline">Georgia O'Keeffe's Artistic Career</h3>
                </div>
                <div className="column">
                  This timeline delineates the artwork Georgia O’Keeffe created throughout her lifetime. When exact dates are unclear, the artwork is charted at the center of the identified date range. Click “View Works” to see larger images and full object information below.
                </div>
              </div>
              <div  className="viz-display">
              <div className="viz-filter is-hidden-mobile">
                  <h4 className="viz-filter-label">Date Range</h4>
                  <input aria-label="Date Range beginning" className="input" type="text" value={`${earlyDate}`} onChange={ (e) => { if (Number(e.target.value)) { setEarlyDate(Number(e.target.value)) } } }></input>
                  <span>to</span>
                  <input aria-label="Date Range ending" className="input" type="text" value={`${lateDate}`} onChange={ (e) => { if (Number(e.target.value)) { setLateDate(Number(e.target.value)) } } }></input>
                  <button className="button button-main" disabled={!canApply} onClick={ () => applyDateRangeHandler() } >Apply</button>
                  <button className="button button-icon ml-3" disabled={!canReset} onClick={ (e) => resetPlotHandler() }><span className="icon icon-revert icon--black"> </span><span className="button-text">Reset</span></button>

                  <div className="viz-filter-right">
                  <button className="button button-icon is-hidden" ><span className="icon icon-share icon--black"> </span><span className="button-text">Share</span></button>
                  <button className="button button-icon" onClick={downloadImageHandler} ><span className="icon icon-download icon--black"> </span><span className="button-text">Download</span></button>
                  <div className="field has-addons">
                    <div className="control">
                    <button className="button" aria-label="zoom in" disabled={!canZoomIn} onClick={ () => zoomInstance.current?.scaleBy(d3.select(vizRef.current).select('.hero-visualization').transition(250),1.5) }><span className="icon icon-zoom-in icon--black"> </span></button>
                    </div>
                    <div className="control">
                    <button className="button" aria-label="zoom out" disabled={!canZoomOut} onClick={ () => zoomInstance.current?.scaleBy(d3.select(vizRef.current).select('.hero-visualization').transition(250),0.5) }><span className="icon icon-zoom-out icon--black"> </span></button>
                    </div>
                  </div>

                  </div>
              </div>
              <div className="viz-title">
                <h4 className="viz-title-text">Number of artworks created over her lifetime </h4>
                <label className="checkbox is-hidden">
                    <input className="custom-checkbox" type="checkbox" checked={showAnnotations} onChange={ (e) => setShowAnnotations(e.target.checked) }/>
                    Show Locations where O’Keeffe lived
                  </label>
                </div>
                <div className="m-10" id="viz-div">
                  <figure ref={vizRef} className="hero-visualization-figure" style={{maxWidth: 'initial', display: 'flex'}}>
                    <div className="counts-color-legend-swatches counts-color-legend-swatches-columns is-hidden-mobile" style={{columnWidth: 'auto', columnCount: 1}}>
                      <ColorSwatchCheckboxes colors={barColors} domain={techDomain} filters={filt} checkboxHandler={checkboxHandler}/>
                      <div className="view-works">
                        <button className="button-main" onClick={viewWorksHandler}>View Works</button>
                      </div>

                    </div>
                  </figure>
                </div>
              </div>
              <div className="button-section is-hidden-tablet">
                <button className="button-main" onClick={viewWorksHandler}>View Works</button>

                <button className="button button-icon ml-3" disabled={!canReset} onClick={ (e) => resetPlotHandler() }><span className="icon icon-revert icon--black"> </span><span className="button-text">Reset</span></button>
              </div>
              <div className="accordion is-hidden-tablet" id="vizFiltersAccordion">
                <div className="card" key="key-filters-accordion-card-date-range">
                  <div  className="mfp-collapse-hdg"
                  id="heading-date-range">
                    <h2
                        className="accordion-title">
                      <button
                        className= {`accordion-title btn btn-link accordion-title mfp-heading-text ${openPane === 'date-range' ? "" : "collapsed"}`}
                        data-target="#collapse-date-range"
                        aria-expanded="false"
                        aria-controls="#collapse-date-range"
                        onClick={() => setOpenPane(prevOpen => (prevOpen === 'date-range'? null : 'date-range'))}
                        >
                        <i className="icon icon-accordion-carets icon--slate-gray pr-1 mr-2"></i>

                        <span className="pr-1">Date:</span><span className="fw-bold">{`${activatedFilters.startDate} - ${activatedFilters.endDate}`}</span>
                      </button>
                    </h2>
                  </div>
                  <div
                  id="collapse-date-range"
                  className={`collapse ${openPane === 'date-range' ? "is-active" : ""}`}
                  aria-labelledby="heading-date-range"
                  data-parent="vizFiltersAccordion"
                  style={openPane === 'date-range'
                      ? { height: "auto" }
                      : { height: "0px" }
                  }
                >
                  <div className="viz-filter px-3">
                    <h4 className="viz-filter-label">Date Range</h4>
                    <input aria-label="Date Range beginning" className="input" type="text" value={`${earlyDate}`} onChange={ (e) => { if (Number(e.target.value)) { setEarlyDate(Number(e.target.value)) } } }></input>
                    <span>to</span>
                    <input aria-label="Date Range ending" className="input" type="text" value={`${lateDate}`} onChange={ (e) => { if (Number(e.target.value)) { setLateDate(Number(e.target.value)) } } }></input>
                    <button className="button button-main" disabled={!canApply} onClick={ () => applyDateRangeHandler() } >Apply</button>
                  </div>
                </div>

                </div>
                <div className="card" key="key-filters-accordion-card-color-filter">
                  <div  className="mfp-collapse-hdg"
                  id="heading-color-filter">
                    <h2
                        className="accordion-title">
                      <button
                        className= {`accordion-title btn btn-link accordion-title mfp-heading-text ${openPane === 'color-filter' ? "" : "collapsed"}`}
                        data-target="#collapse-color-filter"
                        aria-expanded="false"
                        aria-controls="#collapse-color-filter"
                        onClick={() => setOpenPane(prevOpen => (prevOpen === 'color-filter'? null : 'color-filter'))}
                        >
                        <i className="icon icon-accordion-carets icon--slate-gray pr-1 mr-2"></i>

                        <span className="pr-1">Techniques:</span><span className="fw-bold">{`${ techDomain.length - filt.length } Selected`}</span>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapse-color-filter"
                    className={`collapse ${openPane === 'color-filter' ? "is-active" : ""}`}
                    aria-labelledby="heading-color-filter"
                    data-parent="vizFiltersAccordion"
                    style={openPane === 'color-filter'
                        ? { height: "auto" }
                        : { height: "0px" }
                    }
                  >
                 <div className="px-3 pb-2 counts-color-legend-swatches counts-color-legend-swatches-columns" style={{columnWidth: 'auto', columnCount: 1}}>
                    <ColorSwatchCheckboxes colors={barColors} domain={techDomain} filters={filt} checkboxHandler={checkboxHandler}/>
                  </div>
                </div>

                </div>
              </div>
            </div>
            <div>

            <SearchConfigProvider value={{endpoint: endpoint, mapping: dataMapping, searchConfig, filters: activatedFilters }}>
                <div id="view-works"></div>
                <SearchView captive={true} captiveFilterControl={ ( <ColorSwatchCheckboxes inputsDisabled={true} colors={barColors} domain={techDomain} filters={filt} checkboxHandler={checkboxHandler}/> ) } queryString={''} filters={[]} />
              </SearchConfigProvider>
            </div>
        </>
        )
}

document.addEventListener('DOMContentLoaded',() => {
  const el = document.getElementById('visualizationRoot');
  const dataset = el.dataset;

  let endpointPath = dataset.indexName ? `${dataset.indexName}/_search`: 'entity/_search'
  let endpointUrl = new URL(endpointPath, dataset.endpoint);

  // FIXME: Handle any state from the URL params
  // FIXME: Disable the search component's actually setting params?

  // let state = paramsToState(window.location.search)

  ReactDOM.createRoot(el).render(
      <React.StrictMode>
          <Visualization endpoint={endpointUrl.href} filters={[]} title={"Georgia O'Keeffe artworks by year and object type"} dataUrls={{main: `/assets/${csvArtworkDataUrl}`, annotations: [ `/assets/${csvLivedPlacesDataUrl}` ] }} />
      </React.StrictMode>)

})

